import { render, staticRenderFns } from "./pcLayout.vue?vue&type=template&id=437a75e7"
import script from "./pcLayout.vue?vue&type=script&lang=js"
export * from "./pcLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports